import { type CanvasElement, type CanvasElementType } from '@blaze-runtime/engine-domain';

import { hasProps } from '../../../canvas-elements/element-model/element-props-guards';
import { type PropsExtractor } from '../../../elements/__base/props-extractor';
import { type GetPropsExtractorFn } from '../../../services/element-definitions.service';

const extractorsMap: Partial<Record<CanvasElementType, PropsExtractor<CanvasElementType>>> = {};
export function getElementPropsExtractor(
  element: CanvasElement,
  getPropsExtractor: GetPropsExtractorFn,
): PropsExtractor<CanvasElementType> | undefined {
  let extractor = extractorsMap[element.type as CanvasElementType];
  const props = hasProps(element) ? element.props : undefined;
  if (!extractor) {
    extractor = getPropsExtractor(element.type, props);
    extractorsMap[element.type] = extractor;
  } else {
    extractor.setProps(props);
  }
  return extractor;
}
